<template>
	<Autocomplete
		:params="params"
		:icon="icon"
		:label="label"
		:endpoint="endpoint"
		:name="name"
		display-name="Meldungsart(en)"
		data-test="report-types"
		item-title="name"
		v-bind="$attrs"
	>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '../Validation/Autocomplete.vue'

// AAR-2090: Reihenfolge wie in der Verwaltung festgelegt
const params = {
	od: 'ASC',
	of: 'ordering',
	pageSize: 25,
}

defineProps({
	icon: {
		default: '',
		type: String,
	},
	label: {
		default: 'component.reports.category',
		type: String,
	},
	name: {
		default: 'report_types',
		type: String,
	},
	endpoint: {
		default: 'report_types',
		type: String,
	},
})
</script>

<style scoped></style>
